/**
 * @description: 检查当前组织是否为项目级(orgType=6)，如果不是则自动切换到第一个项目
 * @returns {Promise<boolean>} 返回是否可以继续执行后续逻辑
 *
 * 使用方式：
 * onMounted(async () => {
 *   const shouldContinue = await useProjectLevelCheck();
 *   if (!shouldContinue) return;
 *
 *   // 后续逻辑...
 *   getList();
 * });
 */
import { useOrgStore } from '@/store/org';

export const useProjectLevelCheck = async (): Promise<boolean> => {
  const orgStore = useOrgStore() as any;

  const orgType = orgStore.currentOrgInfo.type;

  if (+orgType !== 6) {
    const orgInfo = await orgStore.getFirstProjectInfo();
    orgStore.setCurrentOrgInfo(orgInfo, true);
    return false;
  }

  return true;
};
